const actions = {
  START_FETCH_COMMENTS: 'rent/START_FETCH_COMMENTS',
  END_FETCH_COMMENTS: 'rent/END_FETCH_COMMENTS',
  START_DELETING_COMMENTS: 'rent/START_DELETING_COMMENTS',
  END_DELETING_COMMENTS: 'rent/END_DELETING_COMMENTS',
  SET_COMMENTS: 'rent/SET_COMMENTS'
};

export default actions;
